export default "__VITE_ASSET__CaW7uif5__"